import { Col, Nav, Row } from "react-bootstrap";
import { NavLink, Outlet } from "react-router-dom";
import { docsManifest } from "./manifest";
import "./docs.scss";

export default function DocsLayout() {
  return (
    <Row>
      <Col md={3} lg={2} className="docs-sidebar py-3">
        <Nav className="flex-column">
          {docsManifest.map((section) => (
            <div key={section.title} className="mb-3">
              <h6 className="px-3 text-uppercase small fw-bold">
                {section.title}
              </h6>
              {section.pages.map((page) => (
                <div key={page.path}>
                  <Nav.Link
                    as={NavLink}
                    to={`/internal-docs/${page.path}`}
                    className="py-1 px-3"
                    end={page.path === ""}
                  >
                    {page.title}
                  </Nav.Link>
                  {page.children?.map((child) => (
                    <Nav.Link
                      key={child.path}
                      as={NavLink}
                      to={`/internal-docs/${child.path}`}
                      className="py-1 px-3 ps-4 small"
                    >
                      {child.title}
                    </Nav.Link>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </Nav>
      </Col>
      <Col md={9} lg={10} className="docs-content py-3 ps-4">
        <Outlet />
      </Col>
    </Row>
  );
}
